export default __webpack_public_path__ + "static/media/G0001.c376e469.png";